/**
 * Reports → Call Reports → Inbound Call Report.
 *
 * Aggregated per interval × campaign × queue — the capacity view, as against
 * Call History's per-call list. Opens on the hourly interval because that is
 * the grain staffing decisions are made on.
 */
import type { JSX } from 'react'
import { PhoneIncoming } from 'lucide-react'

import InboundCallAnalytics from '../../../components/reports/calls/InboundCallAnalytics.js'
import {
  INBOUND_CALL_COLUMNS,
  INBOUND_CALL_REPORT_ID,
} from '../../../components/reports/calls/columns.js'
import CallReportPage from './CallReportPage.js'

export default function InboundCallReportPage(): JSX.Element {
  return (
    <CallReportPage
      Icon={PhoneIncoming}
      title="Inbound Call Report"
      intro="Inbound volume and service, per interval — offered, answered, and where the rest were lost"
      unit="interval"
      path="/reports/calls/inbound"
      reportId={INBOUND_CALL_REPORT_ID}
      catalog={INBOUND_CALL_COLUMNS}
      fields={['queues', 'campaigns']}
      windowNote="The window is on the time each call started. Inbound calls only."
      defaultInterval="60m"
      searchPlaceholder="Search intervals…"
      renderAnalytics={(rows) => <InboundCallAnalytics rows={rows} />}
      emptyDescription="Choose a start date, an end date and an interval in Filters, then run the report."
      noResultsTitle="No inbound calls in this window"
      noResultsDescription="No inbound call arrived in the selected scope. Try widening the window, or clearing the queue and campaign filters."
    />
  )
}
